import { logger } from '@superbet-group/web.lib.utilities';

import {
    BonusConditions,
    BonusEventType,
    ConditionDetail,
} from '@core/models/bonus/BonusConditions';

import {
    BonusIncludedDto,
    IncludedDetailDto,
    IncludedEventTypeDto,
} from '@app/promotionHub/bonuses/types/betlerDto/BonusIncludedDto';

export function transformBonusConditionsMap(dto: BonusIncludedDto): BonusConditions {
    return {
        events: dto.event_id ? transformCondition(dto.event_id) : [],
        tournaments: dto.tournament_id ? transformCondition(dto.tournament_id) : [],
        categories: dto.category_id ? transformCondition(dto.category_id) : [],
        sports: dto.sport_id ? transformCondition(dto.sport_id) : [],
        games: dto.cms_game_id ? transformCondition(dto.cms_game_id) : [],
        ...(dto.odds?.total_odds) ? { minTotalOdd: dto.odds.total_odds.value } : null,
        ...(dto.odds?.min_odds) ? { minEventOdd: dto.odds.min_odds.value } : null,
        ...(dto.phase) ? { bonusEventType: getEventType(dto.phase) } : null,
        ...(dto.ticket_type) ? { bonusTicketType: dto.ticket_type } : null,
    };
}

function transformCondition(conditions: IncludedDetailDto[]): ConditionDetail[] {
    return conditions.map((condition) => ({
        id: parseInt(condition.id),
        name: condition.name,
    }));
}

function getEventType(eventTypeDto: IncludedEventTypeDto): BonusEventType {
    const eventType = eventTypeMappings[eventTypeDto];
    if (!eventType) {
        logger.error(new Error(`Undefined type for bonus event type: ${eventTypeDto}`));
    }
    return eventType;
}

const eventTypeMappings: Record<IncludedEventTypeDto, BonusEventType> = {
    [IncludedEventTypeDto.InPlay]: BonusEventType.Live,
    [IncludedEventTypeDto.PreMatch]: BonusEventType.PreMatch,
    [IncludedEventTypeDto.Mixed]: BonusEventType.Mixed,
};
